// Readings of a headword, for pages that show more than one.
//
// Almost every Thai word has a single pronunciation, held word-level as
// thai_words.t2e. Heteronyms don't: สระ is สะ for "pool" and "[to] wash" but
// สะ-หฺระ for "vowel", so those senses carry a phonetic_override and the word
// page has several readings to show. See ai/thai-heteronyms/.

type MeaningReading = {
   phoneticOverride?: string | null
}

// Trim, drop blanks, keep first-seen order. Used on respellings and on their
// romanizations alike — two respellings can romanize identically under a given
// scheme, so the deduping has to happen again after transliteration.
export const distinctNonEmpty = (values: readonly (string | null | undefined)[]): string[] => {
   const distinct: string[] = []
   const seen = new Set<string>()
   for (const value of values) {
      const trimmed = value?.trim()
      if (!trimmed || seen.has(trimmed)) continue
      seen.add(trimmed)
      distinct.push(trimmed)
   }
   return distinct
}

// Every distinct reading of a word: the word-level respelling first, then each
// sense's heteronym override in the order the senses are given (display order,
// as the worker sends them). Returns one entry for an ordinary word.
export const distinctReadings = (phonetic: string, meanings: readonly MeaningReading[]): string[] =>
   distinctNonEmpty([phonetic, ...meanings.map((meaning) => meaning.phoneticOverride)])
